
import { Component, Prop, Vue } from "vue-property-decorator";
import { ExamV2Custom } from "@/lib/model/exambuilder/exam-v2";
import {
  StructConfigGroup,
  StructDimensionGroupConfig,
  EnumReadingGuidelinesType
} from "@/lib/model/exambuilder/configGroup";

class CurrentConfig {
  groupName = ""; // 维度组名
  showChart = 0; // 是否显示图表
  showComport = 0; // 是否显示行为表现
  showEvaluate = 0; // 是否显示评价
  readingGuidelinesType =
    EnumReadingGuidelinesType.EnumReadingGuidelinesTypeCommon; // 阅读指引维度组类型
  readingGuidelinesMessage = ""; // 阅读指引进阶能力类型结果说明
  iconUrl = ""; // 图标链接
  dimensionKeyList = []; // 维度键列表 []string
  popShow = false;
}

@Component({})
export default class ReportSet extends Vue {
  @Prop({}) exam!: ExamV2Custom;
  visible = false;
  groupId = 0;
  sortTo = 0;
  templateList: StructConfigGroup[] = [];
  iconUrlList: string[] = [];
  // 进阶能力
  enumTypeCustom = EnumReadingGuidelinesType.EnumReadingGuidelinesTypeCustom;
  enumReadingGuidelinesType = [
    {
      label: "通用素质",
      value: EnumReadingGuidelinesType.EnumReadingGuidelinesTypeCommon
    },
    {
      label: "岗位匹配度",
      value: EnumReadingGuidelinesType.EnumReadingGuidelinesTypeMatch
    },
    {
      label: "职业规划",
      value: EnumReadingGuidelinesType.EnumReadingGuidelinesTypeJob
    },
    {
      label: "进阶能力",
      value: EnumReadingGuidelinesType.EnumReadingGuidelinesTypeCustom
    }
  ];
  dimensionGroupConfigList: CurrentConfig[] = [];
  target: any = null;
  sourceIndex = -1;
  targetIndex = -1;
  nameList: string[] = []; //判重用
  dimensionKeyAll: string[] = []; //判重用

  //当前维度组
  get dimensionGroup() {
    const group = this.templateList.find(
      group => +this.groupId === group.configGroupId
    );
    if (group) {
      if (!this.iconUrlList.length) {
        StructDimensionGroupConfig.get().then(iconConfig => {
          this.iconUrlList = iconConfig;
        });
      }

      if (group.showType === 1 && !this.dimensionGroupConfigList.length) {
        this.dimensionGroupConfigList.push(this.addDimensionConfig());
      }
      return group;
    } else {
      return new StructConfigGroup();
    }
  }
  dimensionKeyChange(str: string) {
    if (!str) {
      this.$message.warning("维度组名称不能为空！！！");
    }
    const targerName = this.nameList.find(name => name === str);
    if (targerName) {
      this.$message.warning("已存在相同维度组名称！！！");
    }
    this.nameList = Array.from(
      new Set(this.dimensionGroupConfigList.map(group => group.groupName))
    );
  }
  // 维度名称不重复
  unDimenGroupNameRepeat(): boolean {
    return this.nameList.length === this.dimensionGroupConfigList.length;
  }
  // 拖拽
  dragEnter(e: any, index: number) {
    e.preventDefault();
    if (this.target) {
      const keyList = document.getElementById(`key${index}`) as HTMLElement;
      if (this.target === keyList || this.target === e.target) return;
      const childList = Array.from(keyList.children);
      this.sourceIndex = childList.indexOf(this.target);
      this.targetIndex = childList.indexOf(e.target);
      if (this.sourceIndex >= 0 && this.targetIndex >= 0) {
        if (this.sourceIndex < this.targetIndex) {
          keyList.insertBefore(this.target, e.target.nextElementSibling);
        } else {
          keyList.insertBefore(this.target, e.target);
        }
      }
    }
  }
  dragOver(e: Event) {
    e.preventDefault();
  }
  dragStart(e: any) {
    if (e) {
      if (e.target) {
        this.target = e.target;
        setTimeout(() => {
          e.target.classList.add("moving");
        }, 0);
      }
      e.dataTransfer.effectAllowed = "move";
    }
  }
  dragEnd(list: string[], index: number) {
    if (this.target) {
      this.target.classList.remove("moving");
      const keyList = document.getElementById(`key${index}`) as HTMLElement;
      const childList = Array.from(keyList.children) as HTMLElement[];
      const targetChild = childList[this.sourceIndex].querySelector(
        ".drag-target"
      ) as HTMLElement;
      if (list[this.sourceIndex] !== targetChild.innerText) {
        this.dimensionGroupConfigList[index].dimensionKeyList = childList.map(
          (node: HTMLElement) => {
            const target = node.querySelector(".drag-target") as HTMLElement;
            return target.innerText;
          }
        ) as never[];
      }
    }
  }
  // 禁用已添加维度键
  isDisable(key: string, list: string[]) {
    return !!list.find(item => item === key);
  }
  openPopShow(config: CurrentConfig) {
    this.dimensionGroupConfigList.forEach(gruop => (gruop.popShow = false));
    config.popShow = true;
  }
  // 添加维度组
  addDimensionConfig() {
    const dimensionConfig = new CurrentConfig();
    return dimensionConfig;
  }
  // 维度组添加、删除操作
  dimensionConfigOperate(index: number, i: number) {
    if (i < 0) {
      const group = this.dimensionGroupConfigList.splice(index, 1);
      if (group[0]) {
        this.nameList.splice(this.nameList.indexOf(group[0].groupName), 1);
        group[0].dimensionKeyList.forEach(key => {
          this.dimensionKeyAll.splice(this.dimensionKeyAll.indexOf(key), 1);
        });
      }
    } else {
      this.dimensionGroupConfigList.push(this.addDimensionConfig());
    }
  }
  addDimenKey(key: string, list: string[]) {
    list.push(key);
    this.dimensionKeyAll = Array.from(
      new Set(this.dimensionKeyAll.concat(list))
    );
  }
  delDimenKey(i: number, list: string[]) {
    const delKey = list.splice(i, 1);
    if (delKey[0]) {
      const index = this.dimensionKeyAll.indexOf(delKey[0]);
      this.dimensionKeyAll.splice(index, 1);
    }
  }
  // 报告模版展示label
  getGroupItemName(group: StructConfigGroup) {
    const showType = ["维度", "维度组"];
    const scoreType = ["题目计分法", "面试计分法"];
    const suggestType = ["关闭", "通用", "陪练"];
    const str = `${group.name}+${showType[group.showType]}+${
      scoreType[group.showType]
    }+${suggestType[group.showType]}`;
    return str;
  }
  unEmpty() {
    const isF = this.dimensionGroupConfigList.every(config => {
      return (
        config.groupName &&
        (config.showChart === 1 ||
          config.showComport === 1 ||
          config.showEvaluate === 1) &&
        config.iconUrl &&
        config.dimensionKeyList.length
      );
    });
    return isF;
  }
  reportSubmit() {
    if (
      this.groupId === 0 ||
      (this.dimensionGroup.showType === 1 && !this.unEmpty())
    ) {
      this.$message.warning("请填写必填项！！！");
      return;
    }
    if (this.dimensionGroup.showType === 1) {
      if (!this.unDimenGroupNameRepeat()) {
        this.$message.warning("维度组名称存在重复项！！！");
        return;
      }
      if (this.dimensionKeyAll.length !== this.exam.dimensionKeyList.length) {
        this.$message.warning("需要将所有的维度都放在相应的维度分组内");
        return;
      }
    }
    this.exam.configGroupId = this.groupId;
    this.exam.configGroup = this.dimensionGroup;
    this.exam.dimensionGroupConfigList = this.dimensionGroupConfigList.map(
      group => {
        const newGroup = new StructDimensionGroupConfig();
        newGroup.assign(group);
        return newGroup;
      }
    );
    this.visible = false;
  }
  async open() {
    this.visible = true;
    this.groupId = this.exam.configGroupId;
    this.dimensionKeyAll = [];
    this.nameList = [];
    this.dimensionGroupConfigList = this.exam.dimensionGroupConfigList.map(
      group => {
        const newGroup = new CurrentConfig();
        if (
          !(
            group.dimensionKeyList.length === 1 &&
            group.dimensionKeyList[0] === ""
          )
        ) {
          Object.assign(newGroup, group);
        }
        this.nameList.push(newGroup.groupName);
        this.dimensionKeyAll = this.dimensionKeyAll.concat(
          newGroup.dimensionKeyList
        );
        return newGroup;
      }
    );
    this.templateList = await StructConfigGroup.get();
  }
  // 排序
  sort(index: number, config: CurrentConfig) {
    let target = this.sortTo - 1;
    if (index === target) {
      return (config.popShow = false);
    }
    if (target > this.dimensionGroupConfigList.length - 1) {
      target = this.dimensionGroupConfigList.length - 1;
    }
    if (target < 0) {
      target = 0;
    }
    const delItem = this.dimensionGroupConfigList.splice(index, 1);
    this.dimensionGroupConfigList.splice(target, 0, ...delItem);
    config.popShow = false;
  }
  //限制正整数
  setSortTo(a: any) {
    this.sortTo =
      Number(a.replace(/[^\d]/g, "")) > 0 ? Number(a.replace(/[^\d]/g, "")) : 0;
  }
}
